module.exports = __webpack_public_path__ + "static/media/memeops_logo.08ee820b.png";